export default __webpack_public_path__ + "static/media/texture_inverted2.068cae7e.png";